/**
 * Guards against open-redirect via `?redirect=https://evil` or `?redirect=//evil`.
 *
 * Control characters are rejected outright: the WHATWG URL parser strips
 * ASCII tab/CR/LF *before* parsing, so "/\t/evil.com" would otherwise
 * resolve to https://evil.com/ despite starting with a single slash.
 * Backslashes are rejected because the parser normalizes "/\" to "//"
 * (protocol-relative).
 */
export const isSafeRedirectPath = (path: string): boolean => {
  if (!path.startsWith("/") || path.startsWith("//") || path.includes("\\")) {
    return false
  }
  for (const char of path) {
    const code = char.charCodeAt(0)
    if (code <= 0x1f || code === 0x7f) return false
  }
  return true
}
